import { AppShell, Flex } from "@mantine/core";

import ActionButtons from "./ActionButtons";
import { PageTitle } from "./PageTitle";

function Header() {
  return (
    <AppShell.Header
      height={60}
      p="md"
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 10,
      }}
    >
      <Flex style={{ width: "100%" }} justify="space-between" align="center">
        <Flex direction="column">
          <PageTitle />
        </Flex>
        <ActionButtons />
      </Flex>
    </AppShell.Header>
  );
}

export default Header;
